export default class Hyperlink {
  public readonly href: string;
  public readonly label: string;

  constructor(href: string, label: string) {
    this.href = href;
    this.label = label;
  }
}
